import type { Action as ActionType } from 'redux';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/throttleTime';
import 'rxjs/add/operator/mergeMap';
import { cardFocus } from '../../state/actions/cards/focus';
import { CARD_NEXT, CARD_PREV, type Action } from '../../state/actions/cards/navigate';
import { cardSingleSelect } from '../../state/actions/cards/selection';
import { openDetailViewDebounced } from '../../state/actions/detail-view';
import {
	getFirstSelectableIssueAscending,
	getFirstSelectableIssueDescending,
	makeGetNextSelectableIssue,
	makeGetPrevSelectableIssue,
	makeIsCardVisibleAndNotCollapsed,
} from '../../state/selectors/card-navigation';
import { getActiveCard } from '../../state/selectors/cards';
import { isDetailViewOpen } from '../../state/selectors/detail-view';
import type { ActionsObservable, MiddlewareAPI } from '../../state/types';

export const cardsNavigateEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$
		.ofType(CARD_NEXT, CARD_PREV)
		.throttleTime(250)
		.mergeMap(({ type, payload }: Action) => {
			const state = store.getState();
			const activeCardId = getActiveCard(state);

			const isActiveCardVisible =
				activeCardId !== undefined ? makeIsCardVisibleAndNotCollapsed(state)(activeCardId) : false;
			const isNext = type === CARD_NEXT;

			const getFirstSelectableIssueFn = isNext
				? getFirstSelectableIssueAscending
				: getFirstSelectableIssueDescending;
			const makeNextOrPrevIssueFn = isNext
				? makeGetNextSelectableIssue
				: makeGetPrevSelectableIssue;

			const nextIssueId =
				activeCardId !== undefined && isActiveCardVisible
					? makeNextOrPrevIssueFn(state)(activeCardId)
					: getFirstSelectableIssueFn(state);

			const attributes = isNext
				? { key: 'j', id: 'nextIssueKeyboardShortcut' }
				: { key: 'k', id: 'previousIssueKeyboardShortcut' };

			payload.fireShortcutAnalyticsFn(attributes);

			if (nextIssueId !== undefined) {
				const actions: ActionType[] = [cardSingleSelect(nextIssueId), cardFocus(nextIssueId)];

				if (isDetailViewOpen(state)) {
					actions.push(openDetailViewDebounced(nextIssueId));
				}

				return Observable.from(actions);
			}

			return Observable.empty<never>();
		});
